import AntLocalization from '../../utils/AntLocalization';

// ─── Date helpers ────────────────────────────────────────────────
export function startOfDay(d) {
    var r = new Date(d); r.setHours(0, 0, 0, 0); return r;
}

export function addDays(d, n) {
    var r = new Date(d); r.setDate(r.getDate() + n); return r;
}

export function addMonths(d, n) {
    var r = new Date(d); r.setMonth(r.getMonth() + n); return r;
}

export function diffDays(a, b) {
    return Math.round((b.getTime() - a.getTime()) / 86400000);
}

export function isSameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function isWeekend(d) {
    var day = d.getDay();
    return day === 0 || day === 6;
}

export function parseDate(value) {
    if (!value) return null;
    if (value instanceof Date) return startOfDay(value);
    if (typeof value === 'number') return startOfDay(value < 1e12 ? new Date(value * 1000) : new Date(value));
    if (typeof value === 'string') return startOfDay(new Date(value));
    return null;
}

export function toISODate(d) {
    if (!d) return '';
    var yyyy = d.getFullYear();
    var mm = d.getMonth() + 1;
    var dd = d.getDate();
    return yyyy + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
}

export function formatDateShort(d) {
    if (!d) return '';
    var dd = d.getDate();
    var mm = d.getMonth() + 1;
    return (dd < 10 ? '0' : '') + dd + '/' + (mm < 10 ? '0' : '') + mm;
}

export function formatDateFull(d) {
    if (!d) return '';
    var dd = d.getDate();
    var mm = d.getMonth() + 1;
    var yy = d.getFullYear();
    return (dd < 10 ? '0' : '') + dd + '/' + (mm < 10 ? '0' : '') + mm + '/' + yy;
}

export function getDayLabel(d) {
    var lang = getLang();
    var names = {
        vi: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
        en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    };
    return (names[lang] || names.vi)[d.getDay()];
}

export function getMonthLabel(d) {
    var lang = getLang();
    var months = {
        vi: ['Th1', 'Th2', 'Th3', 'Th4', 'Th5', 'Th6', 'Th7', 'Th8', 'Th9', 'Th10', 'Th11', 'Th12'],
        en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    };
    return (months[lang] || months.vi)[d.getMonth()];
}

export function getLang() {
    try { return AntLocalization.getLanguage() || 'vi'; } catch (e) { return 'vi'; }
}

export var t = function (obj) { return AntLocalization.translateText(obj); };

// ─── Mode configs ────────────────────────────────────────────────
export var MODE_CONFIG = {
    day: { colWidth: 40, label: 'D' },
    week: { colWidth: 40, label: 'W' },
    month: { colWidth: 22, label: 'M' },
    quarter: { colWidth: 8, label: 'Q' },
    year: { colWidth: 3, label: 'Y' }
};

// ─── Status colors ───────────────────────────────────────────────
export var DEFAULT_STATUS_COLORS = {
    New: '#94A3B8', ToDo: '#94A3B8',
    InProgress: '#3B82F6', WIP: '#3B82F6',
    Release: '#8B5CF6', Open: '#F59E0B', Review: '#F59E0B',
    Done: '#10B981', Close: '#10B981', Closed: '#10B981',
    Overdue: '#EF4444', Cancel: '#D1D5DB'
};

// ─── Position calculations ───────────────────────────────────────
export function getTaskX(taskStart, timelineStart, mode) {
    if (!taskStart || !timelineStart) return 0;
    return diffDays(timelineStart, taskStart) * (MODE_CONFIG[mode] || MODE_CONFIG.week).colWidth;
}

export function getTaskWidth(taskStart, taskEnd, mode) {
    if (!taskStart || !taskEnd) return 0;
    return Math.max(diffDays(taskStart, taskEnd), 1) * (MODE_CONFIG[mode] || MODE_CONFIG.week).colWidth;
}

// ─── Flatten task tree ───────────────────────────────────────────
export function flattenTasks(tasks, parentField, expandedGroups) {
    if (!tasks || !tasks.length) return [];
    var roots = [];
    var childMap = {};

    tasks.forEach(function (t) {
        var parentId = t[parentField || 'parent'];
        if (parentId) {
            if (!childMap[parentId]) childMap[parentId] = [];
            childMap[parentId].push(t);
        } else {
            roots.push(t);
        }
    });

    var result = [];
    function walk(items, level) {
        items.forEach(function (t) {
            var hasChildren = childMap[t.id] && childMap[t.id].length > 0;
            result.push({ ...t, _level: level, _hasChildren: hasChildren });
            if (hasChildren && expandedGroups[t.id] !== false) {
                walk(childMap[t.id], level + 1);
            }
        });
    }
    walk(roots, 0);
    return result;
}

// ─── Compute timeline range from tasks ───────────────────────────
export function computeRange(tasks, startField, endField, mode) {
    var minDate = null;
    var maxDate = null;
    tasks.forEach(function (task) {
        var s = parseDate(task[startField || 'start'] || task.start);
        var e = parseDate(task[endField || 'end'] || task.end);
        if (s && (!minDate || s < minDate)) minDate = s;
        if (e && (!maxDate || e > maxDate)) maxDate = e;
        if (s && !e && (!maxDate || s > maxDate)) maxDate = s;
    });
    if (!minDate) minDate = startOfDay(new Date());
    if (!maxDate) maxDate = addDays(minDate, 30);

    var pad = mode === 'day' ? 2 : mode === 'week' ? 3 : mode === 'month' ? 7 : mode === 'quarter' ? 14 : 30;
    return { start: addDays(minDate, -pad), end: addDays(maxDate, pad) };
}

// ─── Validate date: start <= end ─────────────────────────────────
export function validateTaskDates(start, end) {
    if (!start) return { valid: false, error: 'missing_start' };
    if (end && end < start) return { valid: false, error: 'end_before_start' };
    return { valid: true };
}

// ─── Detect circular dependency ──────────────────────────────────
export function hasCircularDependency(tasks, taskId, depId) {
    var visited = {};
    var taskMap = {};
    tasks.forEach(function (t) { taskMap[t.id] = t; });
    function walk(id) {
        if (id === taskId) return true;
        if (visited[id]) return false;
        visited[id] = true;
        var task = taskMap[id];
        if (!task || !task.dependencies) return false;
        var deps = Array.isArray(task.dependencies) ? task.dependencies : task.dependencies.split(',');
        for (var i = 0; i < deps.length; i++) {
            if (walk(deps[i].trim())) return true;
        }
        return false;
    }
    return walk(depId);
}

// ─── Priority config ─────────────────────────────────────────────
export var PRIORITY_CONFIG = {
    Urgent: { color: '#DC2626', bg: '#FEF2F2', icon: '▲▲', order: 0 },
    High: { color: '#E53E3E', bg: '#FEF2F2', icon: '▲', order: 1 },
    Medium: { color: '#D69E2E', bg: '#FFFBEB', icon: '●', order: 2 },
    Low: { color: '#38A169', bg: '#F0FFF4', icon: '▽', order: 3 },
    None: { color: '#94A3B8', bg: '#F8FAFC', icon: '', order: 4 }
};

// ─── Avatar color from name ──────────────────────────────────────
export function getAvatarColor(name) {
    if (!name) return '#9CA3AF';
    var hash = 0;
    for (var i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    var colors = ['#3B82F6', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#06B6D4', '#F97316', '#6366F1'];
    return colors[Math.abs(hash) % colors.length];
}

export function getInitials(name) {
    if (!name) return '';
    var parts = name.split(' ').filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
}

// ─── Check overdue ───────────────────────────────────────────────
export function isOverdue(endDate, status) {
    if (!endDate) return false;
    if (status === 'Done' || status === 'Close' || status === 'Closed' || status === 'Cancel') return false;
    var end = parseDate(endDate);
    return end && end < startOfDay(new Date());
}

// ─── Mock Data ───────────────────────────────────────────────────
export var MOCK_TASKS = [
    { id: 'P1', name: 'Phase 1: Chuẩn bị', start: '2026-03-16', end: '2026-03-20', progress: 100, status: 'Done', type: 'group' },
    { id: 'T1', name: 'Phân tích yêu cầu', start: '2026-03-16', end: '2026-03-18', progress: 100, status: 'Done', parent: 'P1', assignee: 'Nguyễn Văn A', priority: 'High' },
    { id: 'T2', name: 'Thiết kế database schema', start: '2026-03-18', end: '2026-03-20', progress: 100, status: 'Done', parent: 'P1', assignee: 'Trần Thị B', priority: 'High', dependencies: ['T1'] },
    { id: 'M1', name: 'Design Approved', start: '2026-03-20', end: '2026-03-20', progress: 100, status: 'Done', type: 'milestone' },
    { id: 'P2', name: 'Phase 2: Phát triển', start: '2026-03-21', end: '2026-04-04', progress: 45, status: 'InProgress', type: 'group' },
    { id: 'T3', name: 'Backend API endpoints', start: '2026-03-21', end: '2026-03-28', progress: 70, status: 'InProgress', parent: 'P2', assignee: 'Nguyễn Văn A', priority: 'Urgent', dependencies: ['M1'] },
    { id: 'T4', name: 'Frontend UI components', start: '2026-03-23', end: '2026-04-01', progress: 40, status: 'InProgress', parent: 'P2', assignee: 'Lê Văn C', priority: 'High', dependencies: ['T2'] },
    { id: 'T5', name: 'Unit Tests & coverage', start: '2026-03-26', end: '2026-03-31', progress: 20, status: 'InProgress', parent: 'P2', assignee: 'Phạm Thị D', priority: 'Medium' },
    { id: 'T6', name: 'Integration Test', start: '2026-04-01', end: '2026-04-04', progress: 0, status: 'New', parent: 'P2', assignee: 'Phạm Thị D', priority: 'Medium', dependencies: ['T3', 'T4'] },
    { id: 'P3', name: 'Phase 3: Triển khai', start: '2026-04-05', end: '2026-04-11', progress: 0, status: 'New', type: 'group' },
    { id: 'T7', name: 'UAT Testing', start: '2026-04-05', end: '2026-04-08', progress: 0, status: 'New', parent: 'P3', assignee: 'Trần Thị B', priority: 'High', dependencies: ['T6'] },
    { id: 'T8', name: 'Deploy Production', start: '2026-04-09', end: '2026-04-10', progress: 0, status: 'New', parent: 'P3', assignee: 'Nguyễn Văn A', priority: 'Urgent', dependencies: ['T7'] },
    { id: 'M2', name: 'Go Live', start: '2026-04-11', end: '2026-04-11', progress: 0, status: 'New', type: 'milestone', dependencies: ['T8'] }
];
